import { Box, Button, Flex, FormControl, FormLabel, HStack, Input, NumberInput, NumberInputField, SimpleGrid, Table, Tbody, Td, Text, Textarea, Th, Thead, Tr, useColorModeValue } from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { PessoaType } from "models/person_type";
import { Project } from "models/project_type";
import { OptionType } from "models/select_mode";
import { useEffect, useState } from "react";
import { IoMdContract } from "react-icons/io";
import {
    MdFileCopy,
    MdMessage,
    MdNoteAdd,
    MdNotifications
} from "react-icons/md";
import InputMask from "react-input-mask";
import formatNumber from "views/admin/order/hooks/formatNumber";
interface IJuridicoComponent {
  accountSelected: Project;
  clients : PessoaType[];

}

const JuridicoComponent = ({ accountSelected, clients}: IJuridicoComponent) => {
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
    const mask = "(99) 99999-9999";
    const initialAccountState = {
        custoFixo: 0,
        custoVenda: 0,
        custoProduto: 0,
        lucro: 0,
        custoProdutoLucro: 0,
        precoLiquido: 0,
        imposto: 0,
        descontoValor: accountSelected?.Orcamento?.desconto || 0,
        acrescimoValor: accountSelected?.Orcamento?.acrescimo || 0,
        comissaoValor: accountSelected?.Orcamento?.comissao || 0,
        textoAcrescimo: "0",
        categAcrescimo: accountSelected?.Orcamento?.tipoAcrescimo || "",
        textoComissao: "0",
        categComissao: accountSelected?.Orcamento?.tipoComissao || "",
        textoDesconto: "0",
        categDesconto: accountSelected?.Orcamento?.tipoDesconto || "",
        totalOrder: 0,
      };

    const [accountState, setAccountState] = useState(initialAccountState);



    useEffect(() => {
      const calcula = () => {
        if (accountSelected?.Orcamento?.modeloNegocio) {
          const custofixo =
            (accountSelected?.Orcamento?.modeloNegocio.custoFixo * accountSelected?.Orcamento?.total) /
            100;
          const custovenda =
            (accountSelected?.Orcamento?.modeloNegocio?.custoVenda *
              accountSelected?.Orcamento?.total) /
            100;
          const totalcustoproduto =
            custofixo + custovenda + Number(accountSelected?.Orcamento?.total);
          const lucrovalor =
            (accountSelected?.Orcamento?.modeloNegocio?.metaLucro * totalcustoproduto) / 100;
          const custoprodutolucro = totalcustoproduto + lucrovalor;
          const custoprodutoliquido =
            Number(custoprodutolucro) +
            Number(accountState.comissaoValor) +
            Number(accountState.acrescimoValor) -
            Number(accountState.descontoValor);
          const valorImposto =
            (custoprodutoliquido /
              (100 - accountSelected?.Orcamento?.modeloNegocio?.imposto)) *
              100 -
            custoprodutoliquido;
          let calculaTotal = custoprodutoliquido + valorImposto;
  
          setAccountState({
            ...accountState,
            custoFixo: custofixo,
            custoVenda: custovenda,
            custoProduto: totalcustoproduto,
            lucro: lucrovalor,
            custoProdutoLucro: custoprodutolucro,
            precoLiquido: custoprodutoliquido,
            imposto: valorImposto,
            totalOrder: calculaTotal,
          });
        }
      };
  
      calcula();
    }, [accountSelected, clients]);
  return (
    <>
      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Ações
      </Text>

      <HStack justifyContent={"flex-start"}>
        <Button
          leftIcon={<IoMdContract />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Contrato
        </Button>
        <Button
          leftIcon={<MdNoteAdd />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Tarefas
        </Button>
        <Button
          leftIcon={<MdFileCopy />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Arquivos
        </Button>
        <Button
          leftIcon={<MdMessage />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Mensagens
        </Button>
        <Button
          leftIcon={<MdNotifications />}
          colorScheme="brand"
          size={"sm"}
          variant="solid"
        >
          Notificações
        </Button>
      </HStack>

      <Text
            mt={8}
            fontSize={18}
            color={"#422AFB"}
            fontWeight={"bold"}
            mb={4}
          >
            Faturamento e Contrato
          </Text>
          <SimpleGrid columns={4} spacing={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Responsável Financeiro
              </FormLabel>

              <Input
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Responsável Financeiro"
                fontWeight="500"
                size="md"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Cargo do Responsável Financeiro
              </FormLabel>

              <Input
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Cargo do Responsável Financeiro"

                fontWeight="500"
                size="md"
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Email do Responsável Financeiro
              </FormLabel>

              <Input
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o Email do Responsável Financeiro"

                fontWeight="500"
                size="md"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Telefone do Responsável Financeiro
              </FormLabel>
              <Input
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o Telefone do Responsável Financeiro"
                fontWeight="500"
                size="md"
                as={InputMask}
                mask={mask}
              />
            </FormControl>
          </SimpleGrid>

          <SimpleGrid columns={4} spacing={4} mt={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Responsável Jurídico
              </FormLabel>

              <Input
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Responsável Jurídico"

                fontWeight="500"
                size="md"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Cargo do Responsável Jurídico
              </FormLabel>

              <Input
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Cargo do Responsável Jurídico"

                fontWeight="500"
                size="md"
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Email do Responsável Jurídico
              </FormLabel>

              <Input
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o Email do Responsável Jurídico"

                fontWeight="500"
                size="md"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Telefone do Responsável Jurídico
              </FormLabel>
              <Input
                isRequired={false}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o Telefone do Responsável Jurídico"

                fontWeight="500"
                size="md"
                as={InputMask}
                mask={mask}
              />
            </FormControl>
          </SimpleGrid>

          <Text
            mt={8}
            fontSize={18}
            color={"#422AFB"}
            fontWeight={"bold"}
            mb={4}
          >
            Contatos Adicionais
          </Text>

          <Table variant="striped" color="gray.500" mb="24px" mt="12px">
            <Thead>
              <Tr>
                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #NOME
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #CARGO
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #EMAIL
                  </Flex>
                </Th>

                <Th pe="10px" borderColor={borderColor} cursor="pointer">
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    #TELEFONE
                  </Flex>
                </Th>

               </Tr> 
            </Thead>
            <Tbody>


              {accountSelected.ProjetoContato
                ?.filter((a) => a.tipo === "financeiro")
                .map((item, index) => {
                  return (
                    <Tr key={`${item.id}-${item}-${index}`}>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        <Input
                          defaultValue={item.nome}
                          isRequired={false}
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="text"
                          placeholder="Preencha a Nome do Contato"

                          fontWeight="500"
                          size="md"
                        />
                      </Td>
                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        <Input
                          defaultValue={item.cargo}
                          isRequired={false}
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="text"
                          placeholder="Preencha o Cargo do Contato"

                          fontWeight="500"
                          size="md"
                        />
                      </Td>

                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        <Input
                          defaultValue={item.email}
                          isRequired={false}
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="text"
                          placeholder="Preencha o Email do Contato"
 
                          fontWeight="500"
                          size="md"
                        />
                      </Td>

                      <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                        <Input
                          defaultValue={item.telefone}
                          isRequired={false}
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="text"
                          placeholder="Preencha o Telefone do Contato"

                          fontWeight="500"
                          size="md"
                        />
                      </Td>


                    </Tr>
                  );
                })}
            </Tbody>
          </Table>

          <SimpleGrid columns={2} spacing={4} mt={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Dados de Faturamento
              </FormLabel>

              <Box w={"88%"}>
                <AutoComplete<OptionType, false, GroupBase<OptionType>>
                  size="md"
                  placeholder="Busque os Dados de Faturamento"
                  isRequired={true}
                  name={"faturamento"}
                  options={clients?.map((item) => {
                    return {
                      label: item.nome,
                      value: item.id,
                    };
                  })}
                  defaultValue={{
                    label : clients.find((a) => a.id === accountSelected?.ProjetoPessoa[0]?.pessoaId)?.nome,
                    value: clients.find((a) => a.id === accountSelected?.ProjetoPessoa[0]?.pessoaId)?.id
                  }}
                />
              </Box>

             
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Dados para Contrato
              </FormLabel>
                <AutoComplete<OptionType, false, GroupBase<OptionType>>
                  size="md"
                  placeholder="Busque os Dados para Contrato"
                  isRequired={true}
                  name={"contrato"}
                  options={clients?.map((item) => {
                    return {
                      label: item.nome,
                      value: item.id,
                    };
                  })}
                  defaultValue={{
                    label : clients.find((a) => a.id === accountSelected?.ProjetoPessoa[1]?.pessoaId)?.nome,
                    value: clients.find((a) => a.id === accountSelected?.ProjetoPessoa[1]?.pessoaId)?.id
                  }}
                />



            </FormControl>
          </SimpleGrid>
          <SimpleGrid column={1} spacing={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                mt={4}
                color={"black"}
              >
                Instruções sobre Faturamento e Contrato
              </FormLabel>
              <Textarea
                fontSize="sm"
                height={100}
                ms={{ base: "0px", md: "0px" }}
                placeholder="Preencha as Instruções sobre Faturamento e Contrato"
                fontWeight="500"
                size="md"
              />
            </FormControl>
          </SimpleGrid>

          <Text
            mt={8}
            fontSize={18}
            color={"#422AFB"}
            fontWeight={"bold"}
            mb={4}
          >
            Recuros e informações adicionais
          </Text>

          <SimpleGrid columns={4} spacing={4} mt={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={"black"}
                mb="8px"
              >
                Link de PO, Ficha de cadastro ou Arquivo Relevante
              </FormLabel>

              <Input
                isRequired={true}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Link de PO, Ficha de cadastro ou Arquivo Relevante"
                fontWeight="500"
                size="md"
                disabled={false}
                defaultValue={accountSelected.linkPastaFinalizacao}
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Modelo de Negócio
              </FormLabel>

              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size="md"
                placeholder="Busque o Modelo de Negócio"
                name={"modelo negocio"}
                value={{
                  label: accountSelected?.Orcamento?.modeloNegocio?.nome,
                  value: accountSelected?.Orcamento?.modeloNegocio?.id,
                }}
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Condição de Pagamento
              </FormLabel>

              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size="md"
                placeholder="Busque a Forma de Pagamento"
                name={"formaPagametno"}
                value={{
                  label: accountSelected?.Orcamento?.condicaoPagamento?.nome,
                  value: accountSelected?.Orcamento?.condicaoPagamento?.id,
                }}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Total Orçamento
              </FormLabel>
              <NumberInput
                precision={0}
                step={10000}
                min={0}
                isDisabled
                value={formatNumber(accountState?.totalOrder)}
                onChange={(e: string) => {}}
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
          </SimpleGrid>
    </>
  );
};
export default JuridicoComponent;
